<template>
<div class="chapter">
<div class="inner_page">
<p class="h2">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/acknowledgments">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter001">1. The Beginnings: The Seventeenth and Eighteenth Centuries</a></p>
<p class="toc"><a href="#/chapter002">2. 1800 to the Civil War</a></p>
<p class="toc"><span href="#/chapter003" title="Link target outside of Sample">3. From the Civil War to Prohibition</span></p>
<p class="toc"><span href="#/chapter004" title="Link target outside of Sample">4. Prohibition and Its Aftermath</span></p>
<p class="toc"><span href="#/chapter005" title="Link target outside of Sample">5. The Birth of the Limited Wineries</span></p>
<p class="toc"><span href="#/chapter006" title="Link target outside of Sample">6. Wineries and Vineyards in the Early 1970s</span></p>
<p class="toc"><span href="#/chapter007" title="Link target outside of Sample">7. Winning the Freedom to Succeed</span></p>
<p class="toc"><span href="#/chapter008" title="Link target outside of Sample">8. Stalemates in the 1980s</span></p>
<p class="toc"><span href="#/chapter009" title="Link target outside of Sample">9. The Industry Forges Ahead</span></p>
<p class="toc"><span href="#/chapter010" title="Link target outside of Sample">10. The Industry Comes of Age</span></p>
<p class="toc1"><span href="#/references" title="Link target outside of Sample">Selected References</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?388d0f00